// extracted by mini-css-extract-plugin
export default {"list__item--loading":"ffSz6","list__item--empty":"Y2XpS"};